module.exports = __webpack_public_path__ + "static/media/Accepted.a3888de6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Accepted.svg
// module id = 162
// module chunks = 17